import { right } from "@popperjs/core";

export const ES = {
  feature: {
    auth: {
      login: "Iniciar sesión",
      $login: {
        title: "¡Inicia sesión en tu cuenta!",
      },
      forgot_password: "¿Olvidaste tu contraseña?",
      $forgot_password: {
        title: "¿Olvidaste tu contraseña?",
        message:
          "Introduce tu dirección de correo electrónico abajo y te enviaremos un código para restablecer tu contraseña",
      },
      reset_password: "Restablecer contraseña",
      $reset_password: {
        message:
          "Hemos enviado el código de confirmación a <b>{email}</b>. Proporciona tu nueva contraseña y confírmala nuevamente en el campo de abajo",
        expires_in:
          "El código de confirmación expirará en <b>{time}</b> segundos",
        code_expired: "Código expirado",
        code_expired_message:
          "Tu código de confirmación ha expirado. Por favor, solicita uno nuevo",
      },
      $update_password: {
        success_message: "Tu contraseña se ha actualizado correctamente",
        force_message: "Tu contraseña ha expirado. Por favor, actualízala",
        first_access:
          "Este es tu primer acceso. Por favor, actualiza tu contraseña",
      },
      $recovery_user_password: {
        title: "Recuperar contraseña",
        success_message:
          "El procedimiento de recuperación de contraseña se completó correctamente.\nEl usuario recibirá un correo electrónico con instrucciones para restablecer su contraseña.",
        error_message:
          "El procedimiento de recuperación de contraseña ha fallado.\nPor favor, inténtalo de nuevo.",
        message:
          "Envía a este usuario un correo electrónico con instrucciones para restablecer su contraseña.",
      },
      request_support: "Solicitar asistencia",
      $request_support: {
        message: "Completa el formulario para solicitar asistencia",
        request_type: "Tipo de solicitud",
        $request_type: {
          1: "No puedo iniciar sesión",
          2: "La aplicación no funciona correctamente",
          3: "Tengo una pregunta sobre una funcionalidad",
        },
        success_message:
          "La solicitud de asistencia se ha enviado correctamente.\nRecibirás una respuesta lo antes posible.",
      },
      invitation: "Invitación",
      $invitation: {
        instructions:
          "Introduce la dirección de correo electrónico del nuevo usuario y envía el formulario. El sistema enviará un correo electrónico con instrucciones para completar el registro. La invitación será válida durante 48 horas desde su envío.",
        send_success_message:
          "La invitación se ha enviado correctamente.\nEl usuario recibirá un correo electrónico con instrucciones para aceptarla.",
        accept_success_message:
          "La invitación se ha aceptado correctamente.\nRecibirás un correo electrónico con tus credenciales.",
        pending_invitations: "Invitaciones pendientes",
        pending_invitations_message: "La tabla muestra todas las invitaciones pendientes. Una vez que el enlace de la invitación haya caducado, se mostrará un botón para enviar una nueva invitación.",
        resend_invitation: "Reenviar invitación",
        invitation_expires_date: "Fecha de caducidad de la invitación",
        email_address: "Dirección de correo",
      },
      delete_account: "Eliminar cuenta",
      $delete_account: {
        disclaimer:
          "Este es un texto de ejemplo de descargo de responsabilidad. Al continuar, aceptas que eliminar tu cuenta eliminará de forma permanente todos los datos asociados. Asegúrate de respaldar cualquier información importante antes de continuar. Esta acción no se puede deshacer.",
        alert_message:
          "Atención: eliminar tu cuenta es una acción permanente. Todos tus datos y accesos se perderán. Si tienes dudas, contacta con soporte antes de continuar.",
        success_message:
          "Tu cuenta se ha eliminado correctamente. Todos los datos asociados se han eliminado de forma permanente. Gracias por usar nuestro servicio.",
        process_pending_warning: "<strong>Atención: el paciente {patient_full_name} ha ejercido su derecho a retirar el consentimiento o ha solicitado la eliminación de su cuenta.</strong><br>Te recomendamos descargar los datos del paciente usando la función de exportación disponible en su perfil. Una vez finalizado el periodo de gracia, los datos se eliminarán de forma permanente y no estarán disponibles."
      },
      $withdraw_consent: {
        alert_message:
          "Atención: al retirar tu consentimiento, no podremos procesar tus datos personales para los fines que aceptaste anteriormente. Algunas funciones y servicios podrían dejar de estar disponibles.",
        success_message:
          "Tu consentimiento se ha retirado correctamente. Puedes actualizar tus preferencias en cualquier momento en la configuración de tu perfil.",
      },
      $download_patient_data: {
        success_message:
          "Los datos del paciente se han preparado correctamente y están listos para su descarga. Por favor, guárdalos de manera segura y cumple con la normativa de protección de datos.",
      },
    },
    therapy: {
      name: "Terapia",
      active_therapies: "Terapias activas | Terapia activa | Terapias activas",
      inactive_therapies:
        "Terapias inactivas | Terapia inactiva | Terapias inactivas",
      prescription: "Prescripción",
      intake: {
        $status: {
          0: "Pendiente",
          1: "Tomada",
          2: "Tomada fuera de tiempo",
          3: "No tomada",
        },
        taken: "Tomada",
        taken_in_time: "Tomada a tiempo",
        taken_not_in_time: "Tomada fuera de tiempo",
        not_taken: "No tomada",
        expected: "Esperada",
        total: "Total",
        subtotal: "Subtotal",
      },
      $trend_range: {
        day: "Día",
        week: "Semana",
        month: "Mes",
        year: "Año",
        $frequency: {
          day: "Diario",
          week: "Semanal",
          month: "Mensual",
          year: "Anual",
        },
      },
      $range: {
        from: "Desde",
        to: "Hasta",
      },
      no_data: "No se han recopilado datos",
      no_therapy_scheduled_today: "No hay terapias programadas para hoy",
      no_therapy_scheduled: "No hay terapias programadas",
      provide_therapy: "Agregar nueva terapia",
      drug: "Medicamento",
      prn: "PRN",
      dose: "Dosis",
      overall_adherence: "Adherencia general",
      adherence: "Adherencia",
      intakes_per_day:
        "{count} veces al día | {count} vez al día | {count} veces al día",
      add_all_prn: "Agregar todos los PRN",
      show_prn: "Ver PRN",
      daily_calendar: "Calendario diario",
    },
    home: {
      welcome_message: "¡Buenos días, {name}!",
      welcome_subtitle: "Bienvenido al portal HCP",
      your_center: "Tu centro",
      $stats: {
        center: "Estadísticas del centro",
        total_patients: "Pacientes totales",
        total_caregivers: "Cuidadores totales",
        total_hcps: "Profesionales totales",
        centers_count: "Centros totales",
        countries_count: "Países involucrados",
        patients_invited_count: "Pacientes invitados",
        cargivers_count: "Cuidadores totales",
        patients_activated_count: "Pacientes activados",
        therapies_started_count: "Terapias en curso",
      },
    },
    lists: {
      result_total: "Mostrando <b>{count}</b>",
      result_counts: "Mostrando <b>{count}</b> de <b>{total}</b>",
      result_count_range:
        "Mostrando <b>{start}</b> - <b>{end}</b> de <b>{total}</b>",
      out_of: "de",
    },
    surveys: {
      patient_surveys: "Cuestionarios",
      history: "Historial",
      no_surveys: "No se ha enviado ningún cuestionario",
      treshold: "Umbral recomendado",
      set_priority: "Establecer prioridad",
      modal_message:
        "Una vez establecido, no podrás desactivarlo hasta su vencimiento.",
      typology: {
        table: "Tabla",
        list: "Lista",
      },
      not_available_answer: "N/A",
      PDI: {
        right_eye: "Ojo derecho",
        left_eye: "Ojo izquierdo",
      },
      frequency: "Frecuencia",
      $frequency: {
        D: "Diario",
        M: "Mensual",
        Y: "Anual",
        O: "Una vez",
      },
      value_representation_type: "Tipo de representación de valores",
      $value_representation_type: {
        integer: "Entero",
        percentage: "Porcentaje",
        other: "Otro",
      },
      min_value: "Valor mínimo",
      max_value: "Valor máximo",
      min_label: "Etiqueta mínima",
      max_label: "Etiqueta máxima",
      step_increment: "Incremento de paso",
      key_recommendations:
        "Proporciona una clave única para identificar el cuestionario (por ej. cuestionario_preliminar)",
      is_notifiable: "Enviar notificaciones",
      default_frequency_days: "Frecuencia de notificación en días",
      default_notification_time: "Hora de notificación",
      extra: "Extra (formato JSON)",
      $steps: {
        key_recommendations:
          "Proporciona una clave única para identificar el paso (por ej. dolor_hoy)",
        add: "Agregar paso",
        save: "Guardar paso",
        delete: "Eliminar paso",
        discard_changes: "Descartar cambios",
        type: "Tipo",
        $type: {
          R: "Radio",
          T: "Texto",
          V: "Valor",
          D: "Descripción",
          F: "Finalizar",
          VSS: "Sentimiento",
          VAS: "Escala analógica visual",
          PDI: "Puntos de interés",
          TS: "Rango de tiempo",
        },
        raw: "Bruto",
        editor: "Editor",
        drag_reorder: "Arrastra y suelta para cambiar el orden de los pasos",
      },
      display_in_chart: "Mostrar en gráfico",
      chart_type: "Tipo de gráfico",
      $chart_type: {
        line: "Línea",
        bar: "Barras",
        body_map: "Mapa corporal",
      },
      labels: {
        bar_y_label: "Número de respuestas dadas",
      },
      required: "Obligatorio",
      include_na_option: "Incluir opción /NA",
      conditions: "Condiciones",
      role: "Rol",
    },
    roles: {
      type: "Type",
      $type: {
        A: "Administrador",
        H: "Profesional de salud",
        C: "Cuidador",
        P: "Paciente",
        I: "Interno",
      },
      roles_permissions: "Permisos de los roles",
      centers_permissions: "Permisos de los centros",
      $permissions: {
        index: "Listar",
        show: "Ver",
        store: "Crear",
        update: "Actualizar",
        destroy: "Eliminar",
      },
      center_users_management: "Gestión de usuarios",
      zone: "Zona",
      remind_policies: {
        title: "Recordatorio de políticas",
        message:
          "Por favor, recuerda establecer las políticas para el nuevo rol creado ({type}) para garantizar un acceso y cumplimiento adecuados.",
      },
      journey_schemas: "Journey Schemas",
      remind_journey_schemas: {
        title: "Recordatorio Journey Schemas",
        message: "Asigne Journey Schema a este rol para definir la experiencia del paciente según su rol.",
      },
    },
    contents: {
      $categories: {
        visible: "Visible",
        visibility: "Visibilidad",
        $visibility: {
          all: "Público",
          restricted: "Restringido",
          undefined: "",
        },
        visibility_checkbox_message:
          "Las categorías públicas serán visibles por todos los pacientes",
        imageCover: "Portada",
      },
      blocks: "Bloques",
      $blocks: {
        add: "Agregar bloque",
        save: "Guardar bloque",
        delete: "Eliminar bloque",
        discard_changes: "Descartar cambios",
        type: "Tipo",
        $type: {
          text: "Texto",
          image: "Imagen",
          video: "Video",
          html: "HTML",
        },
        raw: "Bruto",
        editor: "Editor",
        drag_reorder: "Arrastra y suelta para cambiar el orden de los bloques",
      },
      content_permissions: "Contenidos del paciente",
      category: "Categoría",
      lang: "Idioma",
      $lang: {
        en: "Inglés",
        it: "Italiano",
        de: "Alemán",
        fr: "Francés",
        es: "Español",
      },
    },
    consents: "Consentimientos",
    $consents: {
      enabled_consents: "Consentimientos asociados",
      hcp_enabled_consents: "Consentimientos asociados a los profesionales",
      role_enabled_consents: "Consentimientos asociados a los rol {role}",
      update: "Hemos actualizado nuestro aviso de privacidad.",
      update_message: "Por favor, revísalo y acéptalo para seguir utilizando la aplicación.",
    },
    consent: {
      draft: "Borrador",
      version_history: "Historial de versiones",
    },
    messages: "Mensajes",
    $messages: {
      send: "Enviar mensaje",
      select_patient_message: "Selecciona un paciente para enviar mensajes",
    },
    $events: {
      all_day: "Todo el día",
    },
    $caregivers: {
      no_caregivers: "No hay cuidadores asignados a este paciente",
    },
    $extra_fields: {
      no_choices: "No se seleccionaron opciones",
    },
  },
  page: {
    home: "Inicio",
    patients: "Pacientes",
    patient: "Paciente",
    caregivers: "Cuidadores",
    add_caregiver: "Agregar cuidador",
    edit_caregiver: "Editar cuidador",
    analytics: "Análisis",
    create_patient: "Crear nuevo paciente",
    edit_patient: "Editar paciente",
    system_users: "Usuarios del sistema",
    invite_user: "Invitar usuario",
    create_user: "Crear usuario",
    edit_user: "Editar usuario",
    users: "Usuarios",
    user: "Usuario",
    centers: "Centros del sistema",
    create_center: "Crear centro",
    edit_center: "Editar centro",
    center: "Centro",
    profile: "Perfil",
    update_password: "Actualizar contraseña",
    roles: "Roles del sistema",
    create_role: "Crear rol",
    edit_role: "Editar rol",
    content_library: "Biblioteca de contenidos",
    contents: "Contenidos",
    content_categories: "Categorías",
    create_content_category: "Crear categoría de contenido",
    edit_content_category: "Editar categoría",
    create_content: "Crear contenido",
    edit_content: "Editar contenido",
    consents: "Consentimientos",
    consent: "Consentimiento",
    create_consent: "Crear consentimiento",
    edit_consent: "Editar consentimiento",
    consent_version: "Versión del consentimiento",
    messages: "Mensajes",
    surveys: "Cuestionarios",
    create_survey: "Crear cuestionario",
    edit_survey: "Editar cuestionario",
    edit: "Editar",
    create: "Crear",
    therapy_trend: "Tendencia de la terapia",
    request_support: "Solicitar asistencia",
    invitation_form: "Formulario de registro",
    zones: "Zonas",
    delete_account: "Eliminar cuenta",
    policies: "Políticas",
    create_edit_zone: "Crear / Editar zona",
    privacy_and_cookies: "Política de Privacidad y Cookies",
    footer_link: {
      privacy_policy: "Política de privacidad",
      cookie_policy: "Política de cookies",
      terms_of_use: "Términos de uso",
    }
  },
  cta: {
    ok: "Aceptar",
    login: "Iniciar sesión ahora",
    logout: "Cerrar sesión",
    submit: "Enviar",
    back_to_login: "Volver a iniciar sesión",
    view: "Ver",
    view_data: "Ver datos",
    hide_data: "Ocultar datos",
    edit: "Editar",
    search: "Buscar",
    clear_filters: "Limpiar filtros",
    delete: "Eliminar",
    $delete: {
      title: "¿Estás seguro?",
      message: "Esta acción no se puede deshacer",
    },
    delete_patient: "Eliminar paciente",
    delete_user: "Eliminar usuario",
    delete_center: "Eliminar centro",
    delete_role: "Eliminar rol",
    delete_category: "Eliminar categoría",
    delete_content: "Eliminar contenido",
    delete_consent: "Eliminar consentimiento",
    delete_event: "Eliminar evento",
    delete_caregiver: "Eliminar cuidador",
    delete_zone: "Eliminar zona",
    confirm: "Confirmar",
    continue: "Continuar",
    discard: "Descartar",
    stop: "Detener",
    $discard: {
      message: "Todo tu progreso se perderá",
    },
    save: "Guardar",
    save_patient: "Guardar paciente",
    save_user: "Guardar usuario",
    save_center: "Guardar centro",
    save_role: "Guardar rol",
    save_category: "Guardar categoría",
    save_content: "Guardar contenido",
    save_consent: "Guardar consentimiento",
    save_consent_version: "Guardar versión",
    save_caregiver: "Guardar cuidador",
    save_zone: "Guardar zona",
    create: "Crear",
    create_patient: "Crear paciente",
    create_user: "Crear usuario",
    create_center: "Crear centro",
    create_role: "Crear nuevo rol",
    create_content_category: "Crear categoría",
    create_content: "Crear contenido",
    create_consent: "Crear consentimiento",
    create_consent_version: "Crear versión",
    restore_consent_version: "Restaurar versión",
    publish_consent: "Publicar versión",
    create_caregiver: "Crear cuidador",
    create_zone: "Crear zona",
    schedule_therapy: "Programar terapia",
    update_password: "Actualizar contraseña",
    show_all: "Mostrar todo",
    send: "Enviar",
    add: "Agregar",
    add_event: "Agregar evento",
    edit_event: "Editar evento",
    save_event: "Guardar evento",
    add_caregiver: "Agregar cuidador",
    load_more: "Cargar más",
    next: "Siguiente",
    recovery_password: "Recuperar contraseña",
    create_survey: "Crear cuestionario",
    save_survey: "Guardar cuestionario",
    delete_survey: "Eliminar cuestionario",
    invite_user: "Invitar usuario",
    accept_invitation: "Aceptar invitación",
    download_patient_data: "Descargar datos del paciente",
    withdraw_consent: "Retirar consentimiento",
  },
  form: {
    first_name: {
      label: "Nombre",
      placeholder: "ej. Juan",
    },
    last_name: {
      label: "Apellido",
      placeholder: "ej. Pérez",
    },
    gender: {
      label: "Género",
      0: "Desconocido",
      1: "Masculino",
      2: "Femenino",
      3: "Otro",
      4: "Transgénero",
      5: "Desconocido",
    },
    birth_date: {
      label: "Fecha de nacimiento",
      placeholder: "dd/mm/aaaa",
    },
    email: {
      label: "Correo electrónico",
      placeholder: "ej. juan@example.com",
    },
    otp: {
      label: "Código OTP",
      placeholder: "Introduce el código OTP enviado a tu correo electrónico",
    },
    password: {
      label: "Contraseña",
      placeholder: "Escribe tu contraseña",
    },
    password_confirmation: {
      label: "Confirmar contraseña",
      placeholder: "Vuelve a escribir tu contraseña",
    },
    current_password: {
      label: "Contraseña actual",
      placeholder: "Escribe tu contraseña actual",
    },
    address: {
      label: "Dirección",
      placeholder: "Agregar dirección",
    },
    city: {
      label: "Ciudad",
      placeholder: "Agregar ciudad",
    },
    region: {
      label: "Región",
      placeholder: "Agregar región",
    },
    zip_code: {
      label: "Código postal",
      placeholder: "Agregar código postal",
    },
    country: {
      label: "País",
      placeholder: "Agregar país",
    },
    location: {
      label: "Ubicación",
      placeholder: "Agregar ubicación",
    },
    phone: {
      label: "Teléfono",
      placeholder: "ej. +34 600 123 456",
    },
    notes: {
      label: "Notas",
      placeholder: "Agregar notas adicionales aquí",
    },
    center_id: {
      label: "Centro",
      placeholder: "Seleccionar centro",
    },
    add_caregiver: {
      label: "Agregar cuidador",
    },
    section: {
      patient_information: "Información del paciente",
      user_information: "Información del usuario",
      anagraph: "Anagráfico",
      credentials: "Credenciales",
      contacts: "Contactos",
      caregiver_information: "Información del cuidador",
      extra: "Extra",
      personal_information: "Información personal",
      department_information: "Información del departamento",
      location: "Ubicación",
    },
    invite_user_instructions:
      "Para activar tu cuenta, completa los campos que aparecen a continuación con la información solicitada. Una vez finalizado, recibirás un correo electrónico con tu contraseña temporal para acceder a la plataforma.",
    created_at: {
      label: "Creado en",
    },
    start_at: {
      label: "Inicio en",
    },
    end_at: {
      label: "Fin en",
      $error: {
        therapy_range_error: "La terapia debe durar al menos {min} días",
      },
    },
    name: {
      label: "Nombre",
    },
    title: {
      label: "Título",
    },
    description: {
      label: "Descripción",
      placeholder: "Agregar descripción",
    },
    website: {
      label: "Sitio web",
    },
    role: {
      label: "Rol",
    },
    role_in_department: {
      label: "Rol en el departamento",
    },
    organization: {
      label: "Nombre de la organización",
    },
    department: {
      label: "Nombre del departamento",
    },
    main_contractor: {
      label: "Contacto principal",
    },
    confirmation_code: {
      label: "Código de confirmación",
      placeholder: "Introduce el código recibido por correo",
    },
    active: {
      label: "Activo",
    },
    value: {
      label: "Valor",
    },
    subtitle: {
      label: "Subtítulo",
    },
    url: {
      label: "URL",
    },
    revision_number: {
      label: "Número de revisión",
      placeholder: "ej. 1.2",
    },
    body: {
      label: "Contenido",
    },
    mandatory: {
      label: "Obligatorio",
      placeholder:
        "Proporciona el mensaje que se mostrará cuando no acepten el consentimiento obligatorio",
    },
    has_checkbox: {
      label: "Casilla de verificación",
      placeholder: "Añade el texto de la casilla",
    },
    select_placeholder: "Selecciona una opción",
    select_file: "Seleccionar archivo",
    subject: {
      label: "Asunto",
      placeholder: "Introduce el asunto",
    },
    message: {
      label: "Mensaje",
      placeholder: "Introduce tu mensaje",
    },
    type: {
      label: "Tipo",
    },
    date: {
      label: "Fecha",
    },
    key: {
      label: "Clave",
    },
    footer: {
      label: "Pie de página",
    },
    assignment_strategy: {
      label: "Estrategia de asignación",
      values: {
        by_hcp: "Por profesional",
        by_center: "Por centro",
        self_registration: "Auto-registro",
      },
    },
    is_registration_enabled: {
      label: "Habilitar el auto-registro de pacientes",
    }
  },
  error: {
    something_went_wrong: "¡Algo salió mal!",
    connection_error:
      "La solicitud no se envió o no hubo respuesta del servidor.\nVerifica tu conexión a Internet.",
  },
  footer_disclaimer: {
    kareena: "",
    sifi_fk: "Todos los derechos reservados - N.º IVA 00122890874",
    fungalk: "Todos los derechos reservados - N.º IVA 00122890874",
  },
  invitation_policies: {
    terms_of_use: 'He leído los <a href="{url}" target="_blank">Términos de Uso</a> y los acepto.',
    privacy_policy: 'Los detalles sobre cómo tratamos tus datos personales se encuentran en nuestra  <a href="{url}" target="_blank">Política de Privacidad</a>.',
    cookie_policy: '<a href="{url}" target="_blank">Política de Cookies</a>.',
  },
  footer_links: {
    terms_of_use: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Terms_of_Use.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Dashboard_Terms_of_Use.pdf",
    },
    privacy_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/Karomy_Platform_Privacy_Notice_Dashboard_Physician.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Platform_Privacy_Notice_Dashboard_Physician.pdf",
    },
    cookie_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Cookie_Policy_EN.pdf',
      fungalk: "",
    },
  },

  "France": 'Francia',
  "Italy": 'Italia',
  "Spain": 'España',
  "United Kingdom": 'Reino Unido',
  "Germany": 'Alemania',
};
